import {z} from '@hono/zod-openapi';

export const imageGenerationSizeSchema = z.enum(['256x256', '512x512', '1024x1024']);
